import { Component, Input } from '@angular/core';

@Component({
  selector: 'rmt-steps',
  templateUrl: 'rmt-steps.html'
})
export class RmtStepsComponent {
  @Input() steps = 1; // maximum steps supported by UI is 10
  @Input() progress = 0;

  stepsArray = Array(this.steps);
  stepWidth = 10;
  
  constructor() {

  }

  ngOnInit() {
    if (this.steps === undefined) {
      this.steps = 1;
    }

    for (let index = 0; index < this.steps; index++) {
      this.stepsArray[index] = this.getDesignFor(index);
    }

    this.stepWidth = Math.abs(80/this.steps);
  }

  getDesignFor(index){
    if (this.progress > index){
      return 'dot dotActive';
    }
    return 'dot';
  }

}



// WEBPACK FOOTER //
// ./src/components/rmt-steps/rmt-steps.ts